import { Box } from "@mui/material";
import { useState } from "react";
import { ActivityLogType } from "../../../../../../../utils/constants";
import AddCommentBox from "./AddCommentBox";
import Comment from "./Comment/Comment";
import ExpandButton from "./ExpandButton";
import Log from "./Log";

export default function ControlActivityLogs({ sortedLogs }) {
  const NEWEST_EVENTS_TO_SHOW_COUNT = 10;
  const [showAllLogs, setShowAllLogs] = useState(false);

  const collapsedLogsCount =
    sortedLogs.length > NEWEST_EVENTS_TO_SHOW_COUNT + 1
      ? sortedLogs.length - NEWEST_EVENTS_TO_SHOW_COUNT - 1
      : 0;

  const firstLog = sortedLogs[0];
  const controlID = firstLog.control_id;

  const displayedLogs = sortedLogs.slice(
    showAllLogs || collapsedLogsCount === 0
      ? 0
      : sortedLogs.length - NEWEST_EVENTS_TO_SHOW_COUNT,
    sortedLogs.length
  );

  return (
    <Box display="flex" flexDirection="column" paddingBottom="24px">
      {!showAllLogs && collapsedLogsCount > 0 && (
        <>
          <Log
            log={firstLog}
            includeBottomVerticalLine={
              sortedLogs.length > 1 &&
              firstLog.log_type !== ActivityLogType.COMMENT &&
              sortedLogs[1].log_type !== ActivityLogType.COMMENT
            }
          />
          <ExpandButton
            logsCount={collapsedLogsCount}
            setShowAllLogs={setShowAllLogs}
            includeBottomVerticalLine={
              sortedLogs[sortedLogs.length - NEWEST_EVENTS_TO_SHOW_COUNT]
                .log_type !== ActivityLogType.COMMENT
            }
            controlId={controlID}
          />
        </>
      )}
      <Box>
        {displayedLogs.map((log, index) => {
          let isLastLog;
          if (showAllLogs || collapsedLogsCount === 0)
            isLastLog = index === sortedLogs.length - 1;
          else isLastLog = index === NEWEST_EVENTS_TO_SHOW_COUNT - 1;

          const nextLogIsComment =
            !isLastLog &&
            displayedLogs[index + 1].log_type === ActivityLogType.COMMENT;

          const isComment = log.log_type === ActivityLogType.COMMENT;

          if (isComment) return <Comment key={log.log_id} log={log} />;

          return (
            <Log
              key={log.log_id}
              log={log}
              includeBottomVerticalLine={
                !isLastLog && !nextLogIsComment && !isComment
              }
            />
          );
        })}
      </Box>
      <AddCommentBox controlID={controlID} />
    </Box>
  );
}
